import { render, staticRenderFns } from "./Nomerpick.vue?vue&type=template&id=643db70c&"
import script from "./Nomerpick.vue?vue&type=script&setup=true&lang=js&"
export * from "./Nomerpick.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Nomerpick.vue?vue&type=style&index=0&id=643db70c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports